import type { ClubMessageData } from '@ps/web-shared-api-types/v1-preview/SwHomeGames';
import { isBefore } from 'date-fns';

export interface WallPosts extends Omit<ClubMessageData, 'roleFlags' | 'flags' | 'created'> {
  roleFlags: number;
  flags: number;
  created: string;
  path: number[];
}

export interface NormalizedWallPosts extends WallPosts {
  comments: WallPosts[];
  latestUpdate: string;
}

const normalizeWallPosts = (posts: WallPosts[]): NormalizedWallPosts[] => {
  if (!posts || !Array.isArray(posts)) return [];

  const wallThreads = posts.filter((p) => p.path && p.path[1] === 0);
  const wallComments = posts.filter((p) => p.path && p.path[1] !== 0);

  const normalisedPosts = [] as NormalizedWallPosts[];

  wallThreads.forEach((p) => {
    const [threadIndex] = p.path;
    normalisedPosts[threadIndex] = { ...p, comments: [], latestUpdate: p.created };
  });

  wallComments.forEach((p) => {
    const [threadIndex, commentIndex] = p.path;

    if (!normalisedPosts[threadIndex]) return;

    normalisedPosts[threadIndex].comments[commentIndex - 1] = p;
    if (isBefore(new Date(normalisedPosts[threadIndex].latestUpdate), new Date(p.created))) {
      normalisedPosts[threadIndex].latestUpdate = p.created;
    }
  });

  normalisedPosts.sort((a, b) =>
    isBefore(new Date(a.latestUpdate), new Date(b.latestUpdate)) ? -1 : 1
  );

  return normalisedPosts;
};

export default normalizeWallPosts;
